import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'tiffany';
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  className = '',
  ...props
}) => {
  const baseStyles =
    'inline-flex items-center justify-center px-6 py-3 rounded-full text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white';

  const variants = {
    // Primary: Black background, white text (Linear style)
    primary: 'bg-black text-white hover:bg-gray-800 focus:ring-black',
    // Secondary: Light Gray background, black text
    secondary: 'bg-gray-100 text-black hover:bg-gray-200 focus:ring-gray-400',
    // Outline: Light border, dark gray text
    outline:
      'border border-gray-200 text-gray-600 hover:text-black hover:border-gray-400 focus:ring-gray-400',
    // Tiffany: Tiffany Blue background, white text
    tiffany: 'bg-[#81D8D0] text-white hover:bg-[#6BC4BC] focus:ring-[#81D8D0]',
  };

  return (
    <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button;
